module.exports = __webpack_public_path__ + "static/media/no_data.4c3db396.gif";